export function getCookie(name) {
  if (process.env.REACT_APP_ENVIRONMENT === "development") {
    return process.env.REACT_APP_DEV_TOKEN || "Bearer YOUR_DEV_TOKEN_HERE";
  }

  const accountsUrl = process.env.REACT_APP_ACCOUNTS_URL;
  const cookieString = document.cookie;
  const cookies = cookieString.split(";");

  for (let i = 0; i < cookies.length; i++) {
    const cookie = cookies[i].trim();

    if (cookie.startsWith(name + "=")) {
      const value = cookie.substring(name.length + 1);
      if (!value) {
        window.location.href = accountsUrl;
      }
      return value;
    }
  }

  document.cookie = "redirectPath=" + window.location.href + "; path=/; domain=.mawalog.com";
  document.cookie = "mawalog=; path=/; domain=.mawalog.com";

  window.location.href = accountsUrl;
  return null;
}

export function header() {
  const token = getCookie("mawalog");

  return {
    "Content-Type": "application/json",
    "Access-Control-Allow-Origin": "*",
    Accept: "application/json",
    ...(token && { Authorization: token }),
  };
}
